import * as React from 'react';

const FootstepsFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd" fill="#010101">
            <path d="M9.9 7.7C9 4.4 7 2 5 2c-.2 0-.4 0-.6.1-2.1.6-3 4-2.1 7.7.6 2.2 1.7 4 2.9 4.9l4.4-1.2c.7-1.5.8-3.6.3-5.8zM11 17.9l-1.5-3-3.6 1 .3 3.5c0 .5.2.9.4 1.3.5.8 1.3 1.3 2.2 1.3.2 0 .5 0 .7-.1.8-.2 1.4-.8 1.7-1.6.3-.7.2-1.6-.2-2.4z" />
        </g>
        <g fill="#010101">
            <path d="M12.9 18.1c-.2.4-.3.9-.3 1.4.1 1.1.8 2.1 1.9 2.5h.7c.6 0 1.1-.2 1.6-.5.6-.5 1-1.3 1-2.1l.1-3.4-3.6-1-1.4 3.1zM19.6 2.1c-.2-.1-.4-.1-.6-.1-1.9 0-4 2.4-4.8 5.7-.6 2.2-.4 4.3.2 5.8l4.4 1.2c1.3-1 2.3-2.7 2.9-4.9.9-3.7 0-7.1-2.1-7.7z" />
        </g>
    </svg>
);

FootstepsFillSvg.displayName = 'FootstepsFillSvg';
export default FootstepsFillSvg;
